import { render } from "./VoipRecharge.vue?vue&type=template&id=3c51efcc"
import script from "./VoipRecharge.vue?vue&type=script&lang=js"
export * from "./VoipRecharge.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "3c51efcc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c51efcc', script)) {
    api.reload('3c51efcc', script)
  }
  
  module.hot.accept("./VoipRecharge.vue?vue&type=template&id=3c51efcc", () => {
    api.rerender('3c51efcc', render)
  })

}

script.__file = "src/views/services/modules/voip/pills/VoipRecharge.vue"

export default script